<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableAgwDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="agwDelmodal = true"
            v-hasPermission="['network:agwMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['network:agwMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="agwDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ agwName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAgw()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableAgwVue = {};
export default {
  name: "TableAgw",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      agwDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      agwName: "",
      columns: [
        {
          title: this.$t("alarms.network.AppGateway.title"),
          key: "name"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.instance.ip"),
          key: "publicIp"
        },
        {
          title: this.$t("alarms.network.AppGateway.resourceGroup"),
          key: "resourceGroup"
        },
        {
          title: this.$t("alarms.instance.region"),
          key: "location"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableAgwDate: []
    };
  },
  beforeCreate: function() {
    tableAgwVue = this;
  },
  created() {
    // 获取AgwMonitorSearch里面的搜索内容
    eventBus.$on("companyId", function(val) {
      tableAgwVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableAgwVue.getAgwData();
    },
    // 分页显示数据
    /****************************************************/
    getAgwData: function() {
      //账户列表分页
      this.$api.agw
        .pageAgw({
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 23,
          companyId: tableAgwVue.companyId
        })
        .then(res => {
          this.tableAgwDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableAgwVue.getAgwData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableAgwVue.getAgwData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.agwName = this.tableAgwDate[index].name;
    },
    removeAgw: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.agw
        .deleteAgw("id", this.tableAgwDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableAgwVue.getAgwData();
            this.isDisable = false;
            this.modal_loading = false;
            this.agwDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/network/agwDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          region: row.location,
          privateIp: row.publicIp,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.name
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/agw/TableAgw.vue